import { getSupplier, getSupplierById, updateSupplier, createSupplier, deleteSupplier } from '@/api/supplier'
import Vue from 'vue'

const state = {
    supplierList: [],
    totalCounts: 0
}

const getters = {
}

const actions = {
  async getSupplierAction({ commit }, payload) {
    try {
      const res = await getSupplier(payload)
      commit('SET_SUPPLIER', res.data)
      return res.data
    } catch (error) {
      throw error.message
    }
  },
    // async getSalesByIdAction({ commit }, id) {
    //     try {
    //         const sales = await getSalesById(id)
    //         return sales.data
    //     } catch (error) {
    //         throw error.message
    //     }

    // },
  async createSupplierAction({ commit }, payload) {
    try {
      const newSupplier = await createSupplier(payload);
      commit('ADD_SUPPLIER', newSupplier.data)
    } catch (error) {
      throw error.message
    }
  },
  async updateSupplierAction({ commit }, payload) {
      try {
          const newSupplier = await updateSupplier(payload.id, payload.data)
          commit("UPDATE_SUPPLIER", newSupplier.data)
          return newSupplier.data
      } catch (error) {
          throw error.message
      }
  },
  async deleteSupplierAction({ commit }, payload) {
    try {
      await deleteSupplier(payload)
      commit('DELETE_SUPPLIER', payload)
    } catch (error) {
      throw error.message
    }
  }
}

const mutations = {
  SET_SUPPLIER(state, payload) {
    state.supplierList = payload.supplierList
    state.totalCounts = payload.totalCounts
  },
  UPDATE_SUPPLIER(state, supplier) {
    Vue.set(state.supplierList, state.supplierList.findIndex(x => x._id === supplier._id), supplier)
  },
  ADD_SUPPLIER(state, sales) {
    state.supplierList.unshift(sales)
    state.totalCounts++
  },
    // UPDATESALES(state, sales) {
    //     Vue.set(state.sales, state.sales.findIndex(x => x._id === sales._id), sales)
    // },
  DELETE_SUPPLIER(state, id) {
    state.supplierList = state.supplierList.filter(e => e._id !== id)
    state.totalCounts--
  },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}